import { Page } from 'utils/page-utils';
import CityAPI from 'api/city';
import { getRouteParam, getUrlParamAsObject, paramNameOptions, } from 'utils/url-utils';
import { formatDateTime } from 'utils/format-date-time';
import UrlUtils from '@spothero/utils/url';
// Note: Mounted is a side effect to aid with cleanup.  Its block scoped.  90% sure this should behave the way we hope
export const useNoResultsGetCities = async ({ mounted, setCities, setApiErrorMsg, reduxState, }) => {
    const { searchState, searchRequestState, monthly, starts, ends, timezone, } = reduxState;
    try {
        const citiesResponse = await CityAPI.getNearestCitiesWithLatLon({
            latitude: searchState?.latitude || searchRequestState?.latitude,
            longitude: searchState?.longitude || searchRequestState?.longitude,
        }, 2);
        if (citiesResponse && mounted) {
            const urlParams = {
                starts: starts ? formatDateTime(starts, timezone) : undefined,
                ends: monthly
                    ? undefined
                    : ends
                        ? formatDateTime(ends, timezone)
                        : undefined,
                monthly: getRouteParam(paramNameOptions.MONTHLY),
                view: getRouteParam(paramNameOptions.VIEW),
                ...getUrlParamAsObject('operator_id'),
            };
            const citiesWithURL = citiesResponse.map((city) => {
                const urlParamsWithCity = {
                    ...urlParams,
                    id: city.id,
                    kind: Page.CITY,
                };
                return {
                    ...city,
                    cityUrl: `/search?${UrlUtils.createQueryString(urlParamsWithCity)}`,
                };
            });
            setCities(citiesWithURL);
        }
    }
    catch {
        // if it fails show text
        setApiErrorMsg('Error retrieving cities.');
    }
};
